import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
interface NavigationProps {
  currentSlide: number;
  goToSlide: (index: number) => void;
}
export function Navigation({
  currentSlide,
  goToSlide
}: NavigationProps) {
  const [isOpen, setIsOpen] = useState(false);
  const links = [{
    name: 'Overview',
    index: 0
  }, {
    name: 'Problem',
    index: 1
  }, {
    name: 'Frontend',
    index: 2
  }, {
    name: 'CMS',
    index: 3
  }, {
    name: 'Workflow',
    index: 4
  }, {
    name: 'Approach',
    index: 5
  }, {
    name: 'Investment',
    index: 6
  }];
  return <nav className="absolute top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-100 h-16 lg:h-20" data-id="element-135">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full" data-id="element-136">
        <div className="flex justify-between items-center h-full" data-id="element-137">
          <div className="flex items-center gap-4" data-id="element-138">
            <img src="https://cdn.magicpatterns.com/uploads/f2hdgrhBa13GC8B16oCnHN/toyota-log.svg" alt="Toyota" className="h-9 md:h-12" data-id="element-139" />
            <div className="w-px h-12 bg-[#80BC41]/30" data-id="element-140"></div>
            <img src="https://cdn.magicpatterns.com/uploads/7Sj6JSkedxavvMrCD56G1H/epic-logo-green.svg" alt="Agency Epic" className="h-11 md:h-16" data-id="element-141" />
          </div>

          <div className="hidden lg:flex items-center gap-6" data-id="element-142">
            {links.map(link => <button key={link.name} onClick={() => goToSlide(link.index)} className={`text-xs font-bold uppercase tracking-wider transition-colors relative py-2 ${currentSlide === link.index ? 'text-[#EB0A1E]' : 'text-gray-400 hover:text-[#1a1a1a]'}`} data-id="element-143">
                {link.name}
                {currentSlide === link.index && <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-[#EB0A1E] rounded-full" data-id="element-144" />}
              </button>)}
          </div>

          <div className="lg:hidden flex items-center gap-3" data-id="element-145">
            <span className="text-xs font-bold text-gray-400 tracking-wider" data-id="element-146">
              {currentSlide + 1}/7
            </span>
            <button onClick={() => setIsOpen(!isOpen)} className="text-gray-600" data-id="element-147">
              {isOpen ? <X className="h-5 w-5" data-id="element-148" /> : <Menu className="h-5 w-5" data-id="element-149" />}
            </button>
          </div>
        </div>
      </div>

      {isOpen && <div className="lg:hidden bg-white border-b border-gray-100 px-4 pt-2 pb-4 space-y-1 shadow-lg absolute top-16 left-0 right-0 z-50" data-id="element-150">
          {links.map(link => <button key={link.name} onClick={() => {
        goToSlide(link.index);
        setIsOpen(false);
      }} className={`block w-full text-left px-3 py-2.5 text-sm font-medium rounded-md ${currentSlide === link.index ? 'text-[#EB0A1E] bg-red-50' : 'text-gray-800 hover:bg-gray-50'}`} data-id="element-151">
              {link.name}
            </button>)}
        </div>}
    </nav>;
}